// extracted by mini-css-extract-plugin
export default {"input":"B_-z","button":"C_-z","selected":"D_-z","unavailable":"E_-z","oos":"F_-z","paperCutDisabledOverlay":"G_-z","image":"H_-z"};